<mat-form-field appearance="outline" (click)="onInputClick()">

  <mat-label>{{label}}</mat-label>

  <input validatorColor id="{{inputHtmlId}}" type="text" aria-label="Number" placeholder="{{placeHolder}}" matInput spellcheck="false"
    autocomplete="false" [formControl]="inputControl" [matAutocomplete]="auto" (blur)="onBlur()">

  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="displayFn"
    (optionSelected)="onOptionSelected($event)">

    <mat-option *ngIf="isLoading$ | async" [disabled]="true">
      Carico&hellip;
    </mat-option>

    <mat-option *ngFor="let option of suggestions$ | async" [value]="option">
      <div class="option-content">

        <ng-container *ngIf="optionImageProvider">

          <img class="option-img" height="25" [src]="(option.id | authImgSource: optionImageProvider) | async">

        </ng-container>

        <span>{{option.value}}</span>
      </div>
    </mat-option>

  </mat-autocomplete>

  <button *ngIf="!!inputControl.value && !inputControl.disabled; else undoFillerSpace" matSuffix mat-icon-button
    aria-label="undo" class="undo-icon" (click)="onUndoClick()">
    <mat-icon>undo</mat-icon>
  </button>

  <ng-template #undoFillerSpace>
    <div matSuffix class="undoFillerSpace"></div>
  </ng-template>

</mat-form-field>
